import {
  api,
  getOptions,
} from './helpers';

const submit = (payload) => api.post('/onlineBook/submit', payload, getOptions());

const review = (payload) => api.post('/onlineBook/review', payload, getOptions());

const getPending = (payload) => api.post('/onlineBook/getPending', payload, getOptions());

const getShared = (payload) => api.post('/onlineBook/getShared', payload, getOptions());

const getPublic = (payload) => api.post('/onlineBook/getPublicBook', payload, getOptions());

export default {
  submit,
  review,
  getPending,
  getShared,
  getPublic,
};
